import { Params } from '@angular/router'
import { PlayerPosition } from '@core/enums/player.enums'
import { PlayerComparisonRequest } from '@core/models/player.models'
import { DualHeader } from '@mediacoach/ui'
import { AggregationSelectable } from '@features/aggregations/models/aggregations.models'

export const preparePlayerComparison = (
  params: Params,
  position: PlayerPosition,
  aggregationDataSource: AggregationSelectable
) => {
  const players: PlayerComparisonRequest = {
    playerA: {
      id: params.id,
      seasonId: params.seasonId || params.vsSeasonId,
      competitionId: params.competitionId || params.vsCompetitionId,
      teamId: params.teamId
    },
    playerB: {
      id: params.vsPlayerId,
      seasonId: params.vsSeasonId,
      competitionId: params.vsCompetitionId,
      teamId: params.vsTeamId
    },
    playerPosition: position,
    aggregationDataSource: aggregationDataSource.id
  }

  return { players, matchId: params.matchId }
}

export const removeDualHeaderTriggers = (dualHeader: Partial<DualHeader>): Partial<DualHeader> => {
  if (dualHeader) {
    const { leftTriggerIcon: _leftTriggerIcon, rightTriggerIcon: _rightTriggerIcon, ...header } = dualHeader
    return header
  }
}
